import schedulesViewStateStore from "../../store/store";
import { IShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../../store/schema/SchedulesViewStateStore";

export default mutatorAction('DELETE_SHIFTS_IN_VIEW', function deleteShiftsInView(
    shiftsToDelete: IShiftEntity[],
    viewState?: SchedulesViewStateStore | IPreviewSchedulePageStore
) {
    let shifts: ObservableMap<string, IShiftEntity> = viewState ? viewState.shiftsInView : schedulesViewStateStore().shiftsInView;
    for (let i = 0; i < shiftsToDelete.length; i++) {
        shifts.delete(shiftsToDelete[i].id);
    }
});
